import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../Components/Header/Header";
import { 
    apiCallAmbassadorApproveRejectRequests, 
    apiCallAmbassadorCancel, 
    apiCallAmbassadorRequests 
} from "../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import EmptyData from "../../Components/EmptyData/EmptyData";
import AmbassadorRequest from "../../Components/Ambassador/AmbassadorRequest";
import CustomPagination from "../../Components/CustomPagination/CustomPagination";
import CustomDropdown from "../../Components/DropDown/CustomDropdown";

const Ambassador = () => {
  const dispatch = useDispatch();
  const statusDropdownItem = ['All', 'Pending', 'Approved', 'Rejected', 'Cancelled'];
  const dateDropdownItem = ['All Time', 'Today', 'This Week', 'This Month', 'Last 6 Months'];

  const isLoading = useSelector((state) => state.isLoading);
  const [ambassadorData, setAmbassadorData] = useState([]);
  const [cancelSubPlanModal, setCancelSubPlanModal] = useState(false);
  const [selectedSubPlan, setSelectedSubPlan] = useState(null);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedRejectItem, setSelectedRejectItem] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [initialPage, setInitialPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [dropdownLabelSelect, setDropdownLabelSelect] = useState('Pending');
  const [dateFilter, setDateFilter] = useState("All Time");

  const fetchAmbassadorReqList = async (selectedPage, statusParam, dateParam) => {
    dispatch(setLoadingTrue());
    try {
      const param = {
        offset: selectedPage + 1,
        limit: 10,
        status: (statusParam ?? dropdownLabelSelect).toUpperCase(),
        dateFilter: dateParam ?? dateFilter,
      };
      const response = await apiCallAmbassadorRequests(param);
      setAmbassadorData(response.data);
      setTotalCount(response?.totalCount ?? 0);
      setInitialPage(selectedPage ?? 0);
    } catch (error) {
      dispatch(setLoadingFalse());
      console.error("Error fetching ambassador list:", error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  useEffect(() => {
    fetchAmbassadorReqList(0);
  }, []);

  const handleApprove = async (item) => {
    dispatch(setLoadingTrue());
    try {
      await apiCallAmbassadorApproveRejectRequests({
        requestId: item?._id,
        status: "APPROVED",
        adminNote: "",
      });
      fetchAmbassadorReqList(initialPage);
    } catch (error) {
      console.log(error);
      dispatch(setLoadingFalse());
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleReject = (item) => {
    setSelectedRejectItem(item);
    setRejectReason("");
    setRejectModal(true);
  };

  const submitReject = async () => {
    if (!rejectReason.trim()) {
      alert("Please enter reason");
      return;
    }

    dispatch(setLoadingTrue());

    try {
      await apiCallAmbassadorApproveRejectRequests({
        requestId: selectedRejectItem?._id,
        status: "REJECTED",
        adminNote: rejectReason,
      });

      setRejectModal(false);
      setSelectedRejectItem(null);
      setRejectReason("");
      fetchAmbassadorReqList(initialPage);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleCancel = (item) => {
    setSelectedSubPlan(item);
    setCancelSubPlanModal(true);
  };

  const handleCancelPlan = async () => {
    if (!selectedSubPlan) return;
    dispatch(setLoadingTrue());
    try {
      await apiCallAmbassadorCancel({
        userId: selectedSubPlan.userId?._id,
        planId: selectedSubPlan.planId?._id,
      });
      setCancelSubPlanModal(false);
      setSelectedSubPlan(null);
      fetchAmbassadorReqList(initialPage);
    } catch (error) {
      dispatch(setLoadingFalse());
      console.error(error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleSelect = (status) => {
    setDropdownLabelSelect(status);
    setInitialPage(0);
    fetchAmbassadorReqList(0, status, dateFilter);
  };

  return (
    <div>
      <div className='astrologers-list-parent padding-top-bottom'>
        <div className='custom-box-user'>
          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={dateFilter}
              items={dateDropdownItem}
              color='blue'
              onSelect={(value) => {
                setDateFilter(value);
                setInitialPage(0);
                fetchAmbassadorReqList(0, dropdownLabelSelect, value);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>

          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={dropdownLabelSelect}
              items={statusDropdownItem}
              color='blue'
              onSelect={handleSelect}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>
        </div>
      </div>

      <div className="Event-custom-style">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">
            Ambassador Requests
          </div>
          <div className="transparentWhite">
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
              <div style={{ width: "22%" }} className="user_name">
                User
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Plan
              </div>
              <div style={{ width: "18%" }} className="user_name">
                Status
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Date
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Action
              </div>
            </nav>

            <AmbassadorRequest 
              data={ambassadorData}
              onApprove={handleApprove}
              onReject={handleReject}
              onCancel={handleCancel}
            />
          </div>
        </div>
      </div>

      {ambassadorData?.length === 0 && !isLoading && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}

      {/* Cancel Modal */}
      {cancelSubPlanModal && (
        <div
          className='modal-category'
          style={{
            zIndex: 999999,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div
            className='modal-content'
            style={{
              backgroundColor: 'rgba(6, 101, 228, 1)',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              width: 'auto',
              maxWidth: '800px',
              textAlign: 'center',
              color: '#fff'
            }}
          >
            <p>Are you sure you want to cancel ambassador access?</p>
            <br />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px'
              }}
            >
              <button
                onClick={handleCancelPlan}
                style={{
                  width: '100px',
                  padding: '10px',
                  backgroundColor: '#d9534f',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={e =>
                  (e.target.style.backgroundColor = '#c9302c')
                }
                onMouseLeave={e =>
                  (e.target.style.backgroundColor = '#d9534f')
                }
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setCancelSubPlanModal(false);
                  setSelectedSubPlan(null);
                }}
                style={{
                  backgroundColor: '#f0ad4e',
                  width: '100px',
                  padding: '10px',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={e =>
                  (e.target.style.backgroundColor = '#ec971f')
                }
                onMouseLeave={e =>
                  (e.target.style.backgroundColor = '#f0ad4e')
                }
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reject Modal */}
      <div
        className={`modal-category ${rejectModal ? "display-block" : "display-none"}`}
      >
        <div className="modal-content bg-Blue grid p-4 relative">
          <span className="close" onClick={() => {
            setRejectModal(false);
            setSelectedRejectItem(null);
          }}>
            &times;
          </span>
          <h2 className="text-white font-medium text-xl text-center my-3">
            {'Reject Request'}
          </h2>
          <div className="Category_name">
            <input
              type="text"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Enter rejection reason..."
            />
          </div>
          <div style={{ marginTop: "20px" }} className="category_button">
            <button className="subcategory-save" onClick={submitReject}>
              Save
            </button>
          </div>
        </div>
      </div>

      {ambassadorData?.length !== 0 && (
        <div className='Custom-Pagination'>
          <CustomPagination
            pageCount={Math.ceil(totalCount / 10)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              fetchAmbassadorReqList(selected);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Ambassador;